import { createUseStyles } from 'react-jss';

const styles = {
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    alignItems: 'center',
    marginTop: '6rem',
  },
  notificationModal: {
    padding: '4rem 2.4rem 2.4rem',
  },
  poweredSection: {
    '& img': {
      maxHeight: '1.5rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
